<template>
    <div class="card card-with-shadow border-0">
        <el-form v-if="active === 1">
          <div class="row">
            <div class="col-sm-12 col-md-12">
              <button
                  type="button"
                  class="btn btn-primary btn-with-shadow float-right"
                  data-toggle="modal"
                  @click="openTaskReportModal"
              >
                {{ $t("Add Report") }}
              </button>
              <task-report-add-modal
                  v-if="isTaskReportAddModal"
                  :table-id="tableId"
                  :task_id="task_id"
                  @close-modal="closeTaskReportAddModal"
              />
            </div>
          </div>
          <app-table
              :id="tableId"
              :options="options"
              @action="getListAction"
          />
      </el-form>
      <el-form v-if="active === 2">
        <div class="row">
            <div class="col-sm-12 col-md-12">
              <button
                  type="button"
                  class="btn btn-primary btn-with-shadow float-right"
                  @click="backTaskReportList"
              >
                {{ $t("back") }}
              </button>
            </div>
          </div>
          <task-report-detail
            :report_id="report_id"
            :report_detail="reportDetail"
          ></task-report-detail>
      </el-form>

      <app-delete-modal
        v-if="deleteConfirmationModalActive"
        :preloader="deleteLoader"
        modal-id="delete-task-report-confirmation"
        @confirmed="confirmed"
        @cancelled="cancelled"
      />
    </div>
  </template>
  
  <script>
  // import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
  import * as actions from "../../../../../Config/ApiUrl";
  import {TableHelpers} from "../../../Demo/Tables/mixins/TableHelpers";
  import {axiosDelete} from "@/app/Helpers/AxiosHelper";

  
  export default {
    // extends: CoreLibrary,
    name: "TaskReport",
    mixins: [TableHelpers],
    data() {
      return {
        deleteConfirmationModalActive: false,
        deleteLoader: false,
        active: 1,
        task_id: 0,
        report_id: 0,
        reportDetail: {},
        preloader: false,
        tableId: "task-report",
        filteredData: {
          status: "",
        },
        search: "",
        rowData: {},
        isTaskReportAddModal: false,
        options: {
          name: this.$t("tab_filter"),
          url: actions.TASK_REPORT_LIST,
          datatableWrapper: false,
          tableShadow: false,
          showHeader: true,
          columns: [
            {
              title: this.$t("title"),
              type: "custom-html",
              key: "title",
              modifier: (value,row) => {
                return `<a class="text-primary cursor-pointer" id="${row.id}"  @click.prevent=${this.myFunction(row)}>${this.$t(value)}</a>`;
              },
            },
            {
              title: this.$t("description"),
              type: "custom-html",
              key: "description",
              modifier: (value) => {
                return `<span>${value}</span>`;
              },
            },
  
          ],
          actions: [
            {
              title: this.$t("view"),
              icon: "eye",
              type: "none",
              component: "app-add-modal",
              modalId: "demo-add-edit-Modal",
            },
            {
              title: this.$t("delete"),
              icon: "delete",
              type: "none",
            },
  
          ],
          showFilter: false,
          // showSearch: true,
          showCount: true,
          // showClearFilter: true,
          paginationType: "pagination",
          responsive: true,
          rowLimit: 5,
          showAction: true,
          orderBy: "desc",
          actionType: "dropdown",
        },
      };
    },
    created() {
      this.options.columns = [...this.options.columns, this.actionObj];
      // this.searchAndSelectFilterOptions();
    },
    methods: {
      openTaskReportModal() {
        this.isTaskReportAddModal = true;
      },
      closeTaskReportAddModal() {
        $("#add-task-report-modal").modal("hide");
        this.isTaskReportAddModal = false;
      },
      getListAction(rowData, actionObj, active) {
        this.rowData = rowData;
  
        if (actionObj.title == this.$t('view')) {
          this.view(rowData.id);
        }
        else if (actionObj.title == this.$t('delete')) {
          this.rowData = rowData;
          this.openDeleteModal();
        }
      },
      view(row) {
        this.active = 2;
        this.report_id = row.id;
        this.reportDetail = row;
      },
      myFunction(rowData){
          let doc = document.getElementById(rowData.id);
          if(doc){
              doc.addEventListener('click', () => {
                this.view(rowData);
              })
          }
      },
      backTaskReportList() {
        this.active = 1;
      },
      openDeleteModal() {
        this.deleteConfirmationModalActive = true;
      },

    /**
     * confirmed $emit Form confirmation modal
     */
      confirmed() {
        let url = `${actions.TASK_REPORT_DELETE}/${this.rowData.id}`;
        this.deleteLoader = true;
        axiosDelete(url)
          .then((response) => {
            this.deleteLoader = false;
            $("#demo-delete").modal("hide");
            this.cancelled();
            if (response.data.type == 'success') {
              this.$toastr.s(response.data.message);
            }
            else {
              this.$toastr.e(response.data.message);
            }
          })
          .catch(({ error }) => {
            // Trigger after error
          })
          .finally(() => {
            this.$hub.$emit("reload-" + this.tableId);
          });
      },
      cancelled() {
        this.deleteConfirmationModalActive = false;
        $('#delete-task-report-confirmation').modal("hide");

        this.reSetData();
      },
      reSetData() {
        this.rowData = {};
      },
    },
    mounted() {
        this.task_id = this.$attrs['props'].id;
        this.options.url = actions.TASK_REPORT_LIST+'?task_id='+this.task_id;
    },
    computed: {
      userRole() {
        return this.$store.state.user.loggedInUser;
      },
    },
  };
  </script>
  